import { LeafDivider } from "./brand/Icons";

export default function Story() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="bg-cream-deep py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1 reveal">
          <div className="relative">
            <img
              src="https://images.pexels.com/photos/30296301/pexels-photo-30296301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Hand-picked Andhra spices"
              className="rounded-2xl w-full h-[420px] md:h-[520px] object-cover shadow-xl"
              data-testid="story-image-1"
            />
            <img
              src="https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Slow dum cooking"
              className="hidden md:block absolute -bottom-10 -right-10 w-56 h-72 object-cover rounded-2xl shadow-2xl ring-4 ring-[#FAF3E7]"
              data-testid="story-image-2"
            />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-4">
            Our Story
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-cocoa leading-[1.05] tracking-tight">
            Built on a single,{" "}
            <span className="gold-underline">stubborn idea</span> —
            <br />
            never water down the heat.
          </h2>

          <LeafDivider label="॥ Andhra Rasa ॥" />

          <p className="text-cocoa-soft text-base md:text-lg leading-relaxed">
            Andhra Biryani Co started in a small kitchen in Vijayawada with one
            family recipe and a stone mortar. We refused to soften the chilli
            for a wider palate, and we still do. Today, three flagship kitchens
            cook the same way — basmati layered over slow-braised meat, sealed
            with dough, and finished on a low flame for hours.
          </p>

          <p className="mt-4 text-cocoa-soft text-base md:text-lg leading-relaxed">
            Every spice is hand-picked. Gongura comes from Krishna district.
            Guntur chillies arrive whole and are pounded the morning of cooking.
            What lands on your table is a handi — never a tray.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            <div data-testid="stat-years">
              <div className="font-display text-4xl text-gold">12+</div>
              <div className="text-xs uppercase tracking-wider text-cocoa-soft mt-1">
                Family Recipes
              </div>
            </div>
            <div data-testid="stat-spices">
              <div className="font-display text-4xl text-gold">27</div>
              <div className="text-xs uppercase tracking-wider text-cocoa-soft mt-1">
                Hand-Picked Spices
              </div>
            </div>
            <div data-testid="stat-guests">
              <div className="font-display text-4xl text-gold">2.4k</div>
              <div className="text-xs uppercase tracking-wider text-cocoa-soft mt-1">
                Guests Weekly
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
